import styled from 'styled-components';
import { rgba } from 'polished';

export const Paragraph = styled.p`
	font-size: 1.5rem;
	color: ${({ theme }) => rgba(theme.white, 0.6)};
	white-space: pre-line;
	margin-top: 1.2rem;
	font-weight: ${({ theme }) => theme.font.normal};
	line-height: normal;
`;

export const Button = styled.button`
	cursor: pointer;
	background: transparent;
	border: none;
	font-size: 1.5rem;
	font-weight: ${({ theme }) => theme.font.distinct};
	color: ${({ theme }) => theme.palette.primary.main};
	line-height: normal;
`;
